export const toMonthName = (monthNumber: number) => {
  const date = new Date();
  date.setMonth(monthNumber);

  return date.toLocaleString('pl-PL', {
    month: 'long',
  });
};
